import { render, staticRenderFns } from "./StaticLabel.vue?vue&type=template&id=070f67da&lang=pug"
import script from "./StaticLabel.vue?vue&type=script&lang=js"
export * from "./StaticLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports